<template>
    <div class="shipping-methods">
      <v-card class="common-card grey lighten-4">
        <h4> نحوه ارسال سفارشات</h4>
        <v-row class="d-flex flex-row  mt-3">
            <v-col cols="12" sm="7" lg="10" >
                <div>
                    <b class="shopPrimary--text">ارسال رایگان:</b>
                </div>
                <div class=" mainFont--text">
                    سفارش‌های بالای {{shippingCosts.freeShippingCost.toLocaleString()
 }} تومان به صورت رایگان ارسال می‌شوند.
        </div>
            </v-col>
        <div class="image-box">
          <img src="Messenger.png" width="250" />
        </div>
        </v-row>
        
        <v-row class="d-flex flex-row  mt-1">
            <v-col cols="12" sm="7" lg="10" >
                <div>
                    <b class="shopPrimary--text">ارسال از طریق پیک:</b>
                </div>
                <div class=" mainFont--text">
            تنها برای مشتریان ساکن تهران امکان ارسال سفارش از طریق پیک وجود دارد و هزینه ارسال برای مناطق مختلف تهران، متفاوت است.
        </div>
            </v-col>
        <div class="image-box">
          <img src="Messenger.png" width="250" />
        </div>
        </v-row>
        <v-row class="d-flex flex-row  mt-1">
            <v-col cols="12" sm="7" lg="10" >
                <div>
                    <b class="shopPrimary--text">ارسال از طریق پست:</b>
                </div>
                <div class=" mainFont--text">
                 ارسال از طریق پست به سراسر کشور انجام می‌شود و هزینه‌ی آن {{  shippingCosts.nonTehranShippingCost.toLocaleString()}} تومان است.
        </div>
            </v-col>
        <div class="image-box">
          <img src="Messenger.png" width="250" />
        </div>
        </v-row>
      </v-card>
    </div>
  </template>
  
  <script>
  import Axios from 'axios'
  export default {
    data() {
      return {
        shippingCosts:{
          freeShippingCost:'',
          nonTehranShippingCost:'',
          tehranShippingCost:[],
        }
      };

    },
    methods:{
      getShippingCost() {
      Axios.get(this.baseUrl + "/onlineShop/options/shippingCosts", {
        headers: {
          Authorization: "Bearer: " + localStorage.getItem("shopToken"),
        },
      })
        .then((res) => {
          if (res.status == 200) {
            this.shippingCosts = res.data;
            localStorage.setItem(
              "shippingCost",
              JSON.stringify(this.shippingCosts)
            );
            
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    },
  mounted(){
    this.getShippingCost();
  },
  };
  </script>
  
  <style lang="scss">
  .shipping-methods {
    overflow: hidden;
    .common-card {
      position: relative; 
      min-height: 300px;
      @media only screen and (max-width: 600px) {
        padding-bottom: 200px !important;
      }
      .image-box {
        position: absolute;
        left: 30px;
        bottom: -22px;
        @media only screen and (max-width: 600px) {
          left: 10px;
 
        }
      }
    }
  }
  </style>
  